/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCurrentUserOrganisation
 */
export interface InternalApiCurrentUserOrganisation {
    /**
     * 
     * @type {number}
     * @memberof InternalApiCurrentUserOrganisation
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCurrentUserOrganisation
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiCurrentUserOrganisation
     */
    features: Array<string>;
    /**
     * 
     * @type {InternalApiCurrentUserOrganisationCurrencyEnum}
     * @memberof InternalApiCurrentUserOrganisation
     */
    currency: InternalApiCurrentUserOrganisationCurrencyEnum;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiCurrentUserOrganisationCurrencyEnum {
    EUR = 'EUR',
    GBP = 'GBP',
    USD = 'USD',
    KES = 'KES',
    UGX = 'UGX',
    ALL = 'ALL',
    KZT = 'KZT',
    HKD = 'HKD'
}


/**
 * Check if a given object implements the InternalApiCurrentUserOrganisation interface.
 */
export function instanceOfInternalApiCurrentUserOrganisation(value: object): value is InternalApiCurrentUserOrganisation {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('features' in value) || value['features'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function InternalApiCurrentUserOrganisationFromJSON(json: any): InternalApiCurrentUserOrganisation {
    return InternalApiCurrentUserOrganisationFromJSONTyped(json, false);
}

export function InternalApiCurrentUserOrganisationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCurrentUserOrganisation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'features': json['features'],
        'currency': json['currency'],
    };
}

export function InternalApiCurrentUserOrganisationToJSON(json: any): InternalApiCurrentUserOrganisation {
    return InternalApiCurrentUserOrganisationToJSONTyped(json, false);
}

export function InternalApiCurrentUserOrganisationToJSONTyped(value?: InternalApiCurrentUserOrganisation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'features': value['features'],
        'currency': value['currency'],
    };
}

